import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { GrammarInUseStore } from 'src/app/stores/resources/grammarInUse';

@Component({
  selector: 'app-grammar-section',
  templateUrl: './grammar-section.component.html',
  styleUrls: ['./grammar-section.component.scss']
})
export class GrammarSectionComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs: any = TABS.PROGRAM_LEVEL;
  LESSON_KEY: any;
  SECTION_KEY:any;
  ITEM: any = null;
  LESSON:any=null;
  LOADING=true;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: GrammarInUseStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(async (param) => {
      const {lessonKey,id}=param;
      this.LESSON_KEY = lessonKey;
      this.SECTION_KEY=id;
      this.tabs = TABS.GRAMMAR_IN_USE_SECTION.map(m => ({ path: `${m.path}/${this.LESSON_KEY}/${this.SECTION_KEY}`, label: m.label }))
      this.LESSON = await this.store.fetchSelectedLesson(this.LESSON_KEY)
      this.ITEM = await this.store.fetchSelectedLesson(this.SECTION_KEY)
      if (!this.ITEM || !this.LESSON) {
        this.router.navigate([`/404`])
        return;
      }
      this.store.fetchData(this.SECTION_KEY);
      this.LOADING=false
    })
  }

  addItem(item: any) {
    this.router.navigate([`/grammar-in-use/content/${this.LESSON_KEY}/${this.SECTION_KEY}/${item ? item.key : 'draft'}`])
  }


  delete(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: item,
      panelClass: 'cs-overlay-panel',
      width: '',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        // this.store.delete(COLLECTION_NAME.LEVEL, item, (success) => {
        //   if (success) {
        //     this.snackBar.open("Level has been deleted successful.", "Done", { duration: 2500 });
        //   }
        // })
      }
    });
  }
}
